import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { barChartOptions, doughnutChartOptions } from "~/misc/charts";
import { initTreeStats } from "~/misc/stats";

export default class extends Controller {
  connect() {
    console.log('initTransactionsStats');
    initTreeStats();

    const doughnut_data = $('#toJs').data('doughnut');
    if (doughnut_data) {
      const ctx = $('#doughnut')[0] as HTMLCanvasElement;
      const options = Object.assign({}, doughnutChartOptions) as any;
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: doughnut_data.datasets,
          labels: doughnut_data.labels
        },
        options: options
      });
    }

    const bar_data = $('#toJs').data('bar');
    if (bar_data) {
      const ctx = $('#bar')[0] as HTMLCanvasElement;
      const options = Object.assign({}, barChartOptions) as any;
      options.scales.x.stacked = true;
      options.scales.y.stacked = true;
      options.scales.x.title.text = 'Hónap';
      options.scales.x.title.display = true;
      options.scales.y.title.text = bar_data.ylabel;
      new Chart(ctx, {
        type: 'bar',
        data: {
          datasets: bar_data.data,
          labels: bar_data.labels
        },
        options: options
      });
    }
  }
}

